<template>
   <v-container fluid> 

        <v-row
        justify="space-between"
        align="center"
        v-if="showHeader"
      >
     <v-col cols="2">
                <v-btn class="mt-n4 material-button" dark @click="designQuery"
                style="float:left; 
                       background-color: transparent !important;
                       color: #185ea9 !important;
                       text-transform: uppercase; 
                       letter-spacing: 0!important;
                       padding: 0 10px!important;
                       padding-right: 0 !important;
                       font-size: .9rem !important;
                       height: 36px !important;
                       line-height: 36px !important;
                       box-shadow: none !important;
                       font-weight: normal !important;"
                > 
                    <v-icon 
                    small
                    class="mr-2">brush</v-icon>
                    {{ $t('wkt.admin.qbuilder.data-viewer.edit_query') }}
                </v-btn>
                <ExportXlsx
                    ref="exportXlsx"
                    style ="visibility:hidden;"
                    :data="data"
                    :columns="headers"
                    :fileName="'tweem_export'"
                    :sheetName="'tweem'"
                    >
                </ExportXlsx>
        </v-col>
        <v-col cols="6" align="center">
                <v-chip color="orange" v-if="rawQuery"
                 text-color="white">{{rawQuery}}</v-chip>
        </v-col>
        <v-col cols="4">
                <v-btn class="mt-n4 ml-4 material-button" color="primary" dark @click="exportData"
                style="float:right; 
                       background-color: transparent !important;
                       color: #185ea9 !important;
                       text-transform: uppercase; 
                       letter-spacing: 0!important;
                       padding: 0 10px!important;
                       padding-right: 0 !important;
                       font-size: .9rem !important;
                       height: 36px !important;
                       line-height: 36px !important;
                       box-shadow: none !important;
                       font-weight: normal !important;"
                >
                    <v-icon
                    small
                    class="mr-2">file_download</v-icon>
                    {{ $t('wkt.admin.qbuilder.data-viewer.export') }}
                </v-btn>
                <v-btn class="mt-n4" color="primary" dark @click="updateData"
                style="float:right; 
                       background-color: transparent !important;
                       color: #185ea9 !important;
                       text-transform: uppercase; 
                       letter-spacing: 0!important;
                       padding: 0 10px!important;
                       padding-right: 0 !important;
                       font-size: .9rem !important;
                       height: 36px !important;
                       line-height: 36px !important;
                       box-shadow: none !important;
                       font-weight: normal !important;"
                >
                    <v-icon
                    small
                    class="mr-2">refresh</v-icon>
                    {{ $t('wkt.admin.qbuilder.data-viewer.refresh') }}
                </v-btn>
        </v-col>  
      </v-row>


       <v-row style="width:100%">
      <v-data-table :loading="isLoading" :disableFiltering="true"
            :headers="headers" 
						ref = "dataTable"
						:loading-text="$t('wkt.admin.common.table.loading')"
						:no-data-text="$t('wkt.admin.common.table.no_data')"
						:no-results-text="$t('wkt.admin.common.table.no_results')"
            :options.sync="options" 
						:server-items-length="parseInt(query.maxResults)"
            :items="data" 
						:disablePagination="true" 
						hide-default-footer
            :fixedHeader="true" 
						:height="tableHeight" 
						style="max-height: calc(100vh - 240px); width: 100%;"
        >
        
        <!-- formateadores dinámicos 
        <template v-for="header in headers.filter((header) => header.hasOwnProperty('formatter'))" v-slot:[`item.${header.value}`]="{ header, value }">
            {{ _self[header.formatter](value, header) }}
        </template>
        -->

        </v-data-table>
     </v-row>

    </v-container>
</template>

<script> 
import BaseModule from '../../common/BaseModule.js'
import worktime from '../../../api/worktime'
import ExportXlsx from '../../common/ExportXlsx';

export default {
  name: 'DataViewer',
  mixins: [BaseModule],
  components: { 
	ExportXlsx
  },
  
  data() {
      return {
        rawQuery: null,
        isLoading: true,
        options: { 
            sortBy : [],
            sortDesc: []},
        headers: [],
        data: [],
        query: { maxResults: 0},
        tableHeight:200,
        showHeader: true,
        autoFixTableHeight: true
      }
  },watch: {
      options: {
        handler () { 
            this.updateData();
        },
        deep: true,
      },
    },
   methods: {
    exportData() {
        this.$refs.exportXlsx.exportExcel();
    },
    designQuery() {
        this.$emit('design')
    },
    executeQuery(query) {

        this.options.sortBy = [];
        this.options.sortDesc = [];

        this.query = query;

        for(var k in this.query.addedColumns) {
            let item = this.query.addedColumns[k];
            item['value'] = item['field'];
            item['text'] = this.$t(item['label']);
            item['desc'] = this.$t(item['desc']);
            item['label'] = this.$t(item['label']);
        }
        this.rawQuery = this.query.rawQuery;
        this.headers = this.query.addedColumns;

        this.showHeader = query.showHeader === false ? false:true;
        this.autoFixTableHeight = query.autoFixTableHeight === false ? false:true;
        this.tableHeight = query.tableHeight? query.tableHeight:200;
    },
    updateData() {
        if (!this.query.entity) return;

        this.isLoading = true;
        this.data = [];
        const { sortBy, sortDesc } = this.options; 

        let dbQuery = {
            'rawQuery' :this.query.rawQuery,
            'entity': this.query.entity,
            'maxResults' : this.query.maxResults,
            'sortBy':sortBy.length>0?sortBy[0]:null,
            'sortDesc':sortDesc.length>0?sortDesc[0]:null
        };
       
        const me = this;
        worktime.executeQuery(dbQuery, res=> {
          me.isLoading=false;
          me.addCustomData(me, res);
          me.data = me.formatData(me,res);
          me.fixLayout(me);
        }, err => {
            alert(err);
            this.isLoading=false;
        })
    },
    fixLayout(vm) {
        if (vm.autoFixTableHeight)
        {
            vm.tableHeight = window.getComputedStyle(vm.$refs.dataTable.$el, null).getPropertyValue("max-height");
        }
    },
    formatData (vm, rows) {
        for (let row of rows) {
            Object.entries(row).forEach(([key, value]) => {
                let field = vm.headers.find ( h => h.field==key);
                if (field && field.formatter)
                {
                    row[key] = vm[field.formatter](value, field);
                }
            });
        }
        return rows;
    },
    addCustomData (vm, rows) {
        for (let header of vm.headers) {
            if (header.customValue) {
                for (let row of rows) {
                    row[header.field] = header.customValue(row);
                }
            }
        }
        return rows;
    },
    formatBoolean (value) {
        return (typeof value === 'undefined' ) ? '' : 
				(value ? this.$t('wkt.admin.common.yes').toUpperCase() : this.$t('wkt.admin.common.no').toUpperCase());
    },
    formatDate (value) {
			//return this.formatLongDate(value);
       return !value ? '' : new Date(value).toLocaleDateString();
    },
    formatDateTime (value) {
        return !value ? '' : new Date(value).toLocaleDateString() + ' ' + new Date(value).toLocaleTimeString();
    },    
    formatDateTimeLocal (value) {
        // muestra la fecha como esta en base de datos (ignora la zona horaria del navegador)
        if (!value) {
            return '';
        }
        
        let dateLocal = new Date(value);
        let timezoneOffset = dateLocal.getTimezoneOffset();
        dateLocal.setTime(dateLocal.getTime() + timezoneOffset * 60 * 1000);

        let dataLocalString = dateLocal.toLocaleDateString() + ' ' + dateLocal.toLocaleTimeString();
        return dataLocalString;
    },
    formatLongDateTime (value) {
			//return this.formatLongDateTime(value, true);
       return !value ? '' : new Date(value).toLocaleDateString() + ' ' + new Date(value).toLocaleTimeString();
    },
    formatSimpleDate (value) {
			//return this.formatLongDate(new Date(value.year, value.month-1, value.day, 0, 0, 0, 0).getTime());
       return !value ? '' : new Date(value.year, value.month-1, value.day, 0, 0, 0, 0).toLocaleDateString();
    },
    formatTime (value) {
        if (!value) return '';

        let avalue = Math.abs(value);

        let sign = avalue==value ? "":"-";
        
        let hours = Math.floor(avalue);
        let mins = Math.floor((avalue - hours) * 60);
        let secs = Math.floor((avalue - hours - mins/60) * 3660);

		if (secs == 60) {
			secs = 0;
			mins = mins +1;
		}

		if (mins == 60) {
			mins = 0;
			hours = hours +1;
		}
        
        return sign + hours + ":" + `${mins}`.padStart(2, '0') + ":" + `${secs}`.padStart(2, '0');
    },
    formatFloat (value) {
        // formatea con 2 decimales
        if (!value) return '';

        let num = Math.round(value * 100) / 100;
        return num;
    },
    formatChoice (value, field) {
        if (!value && value!==0 && value!==false) return '';

        if (!field.choices) return value;

        let choice = field.choices.find ( h => h.key==value);

        if (!choice) return value;

        return this.$t(choice.value);
    }
   }
};
</script>
 